import { SafePromiseCancelableReturn } from '@benzinga/safe-await';
import React from 'react';
import { ActionDropdownItem, AutocompleteDropdownItem } from '../SearchBar';
import { SearchItem } from '@benzinga/search-modules';

export type NoCommaString = string & { __noComma__: void };
export type ModuleState = 'alpha' | 'beta' | 'deprecated' | 'new' | 'production';
export function isNoCommaString(input: string): input is NoCommaString {
  return !input.includes(',');
}

export enum QueryScore {
  NoMatch,
  HistoryMatch,
  IncludesMatch,
  StartsWithMatch,
  FullMatch,
  Priority,
}
export interface AutocompleteModule<T> {
  specifier?: string;
  onSelect: (item: SearchItem) => SearchItem | undefined;
  query: (
    text: string,
    limit: number,
    selectedItems?: SearchItem[],
  ) => SafePromiseCancelableReturn<[SearchItem<T>, QueryScore][]>;
  dropdown: (item: SearchItem) => AutocompleteDropdownItem<T> | undefined;
}

//actions dropdown on clicking an existing tag
export interface ActionModule {
  dropdown: (data: SearchItem) => ActionDropdownItem[] | undefined;
}

export interface TagModule {
  render: (
    item: SearchItem,
  ) =>
    | { type: 'text'; text: React.ReactNode; icon?: React.ReactNode }
    | { type: 'custom'; jsx: React.ReactNode }
    | undefined;
  tagInputText: (item: SearchItem) => string | undefined;
}

export interface ClipboardModule {
  onCopyJSON: (item: SearchItem) => SearchItem[] | undefined;
  onPasteJSON: (pasteItem: SearchItem) => SearchItem | undefined;
  onCopyString?: (item: SearchItem) => NoCommaString[] | undefined;
  onPasteString?: (pasteString: NoCommaString) => SearchItem | undefined;
}

export interface SearchModule<T = unknown> {
  id: string;
  autocomplete: AutocompleteModule<T>;
  tag: TagModule;
  action: ActionModule;
  clipboard: ClipboardModule;
  state?: ModuleState;
  loader: (item: SearchItem) => SearchItem<T> | undefined;
}
